<template>
  <div>

      <h5>申込管理</h5>
      <div class="row">
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">申込者名:</label>
          <input type="text" v-model="searchForm.buyer_name" value="">
        </div>
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">販売者の名前:</label>
          <input type="text" v-model="searchForm.seller_name" value="">
        </div>
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">販売者メールアドレス:</label>
          <input type="text" v-model="searchForm.seller_mail" value="">
        </div>
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">支払ステータス:</label>
          <select v-model="searchForm.payment_status">
            <option value="">未選択</option>
            <option v-for="(item, index) in payment_status" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label for="status" class="d-block col-form-label">種類:</label>
          <select v-model="searchForm.status">
            <option value="">未選択</option>
            <option v-for="(item, index) in status" :value="item.no" :key="`type-${item.no}`">{{ item.name }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <a class="btn btn-info" style="margin-top: 37px;" href="javascript:void(0);" @click="get_orders">検索</a>
        </div>
      </div>
      <hr>

      <div class="py-3 contents">
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th>種類</th>
              <th>申込日</th>
              <th>商品のタイトル</th>
              <th>商品情報</th>
              <th>販売者名称</th>
              <th>申込者名</th>
              <th>メッセージ</th>
              <th>メモ</th>
              <th>状態</th>
            </tr>
            <template v-if="allGetOrders.length > 0">
              <tr v-for="(order, index) in allGetOrders">
                <td>
                  {{ get_hash_value(status, order['type']) }}
                </td>
                <td>
                  {{ convert_jst_for_message(order['created_at']) }}
                </td>
                <td>
                  {{ order['title'] }}
                </td>
                <td>
                  <button class="btn btn-info" @click="jumpProductDetail(order['products_id'])">詳細</button>
                </td>
                <td @click="jumpSeller(order['sellers_id'])">
                  <span v-if="order['legal_person']==1">{{ cinit(order['corp_name'], '-') }}</span>
                  <span v-else-if="order['legal_person']==0">{{ cinit(order['store_name'], '-') }}</span>
                  <!--<span>{{ order['last_name'] + ' ' + order['first_name'] }}</span>-->
                </td>
                <td @click="jumpSeller(order['users_id'])">
                  <span>{{ order['last_name'] + ' ' + order['first_name'] }}</span>
                </td>
                <td>
                  <button class="btn btn-info" @click="jumpMessageDetail(order['type'], order['messages_id'])">詳細</button>
                </td>
                <td>
                  <button class="btn btn-info" @click="jumpMemo(order)">詳細</button>
                </td>
                <td>
                  <template v-if="String(order['type'])=='2'">
                    {{ get_hash_value(payment_status, order['payment_status']) }}
                    <button v-if="String(order['payment_status']) != '4' && String(order['payment_status']) != '9' && String(order['payment_status']) != '0'" class="btn btn-danger d-block mt-2" @click="updateStatus(order['orders_id'], 0)">未払いに変更</button>
                    <button v-if="String(order['payment_status']) != '4' && String(order['payment_status']) != '9' && String(order['payment_status']) != '3'" class="btn btn-danger d-block mt-2" @click="updateStatus(order['orders_id'], 3)">保留に変更</button>
                    <button v-if="String(order['payment_status']) != '4' && String(order['payment_status']) != '9'" class="btn btn-danger d-block mt-2" @click="updateStatus(order['orders_id'], 9)">キャンセルに変更</button>
                  </template>                  
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="9">
                  データが存在しません
                </td>
              </tr>
            </template>
          </table>

          <div class="page" v-show="allGetOrders.length>0">
            <vuejs-paginate
              :page-count="allGetPageCount"
              :page-range="3"
              :margin-pages="2"
              :click-handler="allClickCallback"
              :prev-text="'＜'"
              :next-text="'＞'"
              :container-class="'pagination'"
              :page-class="'page-item'">
            </vuejs-paginate>
          </div>

        </div>
      </div>

      <div id="overlay" class="memo" v-show="displayMemoModal">
        <b-container>
          <div class="memo_modal card text-left m-auto" style="overflow: hidden;">
            <div class="card-header text-left" style="background-color: #fff;">
              <span>メモの確認・編集</span>
            </div>
            <div class="text-center mx-3 mt-3">
              <textarea placeholder="" v-model="memo" class="w-100" rows="6"></textarea>
            </div>
            <b-row class="mb-3">
              <b-col class="text-right px-4">
                <button id="memo_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="update_memo">更新する</button>
                <button id="memo_modal_close" type="submit" class="my-2 mx-md-3 btn btn-primary mr-sm-3 mt-sm-3 w100 p-2 px-sm-3" @click="displayMemoModal=false">閉じる</button>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </div>

  </div>
</template>

<script>
import VueJsPaginate from "vuejs-paginate";

export default {
  components: {
    'vuejs-paginate': VueJsPaginate,
  },
  props: { 
    user: Object
  },
  data() {
		const payment_status = [
			{"no":"0","name":"未払い"},
			{"no":"1","name":"振込済み"},
			{"no":"2","name":"振込確認中"},
			{"no":"3","name":"保留"},
			{"no":"4","name":"完了（支払い済み）"},
			{"no":"9","name":"キャンセル"},
    ];
		const status = [
			{"no":"2","name":"購入申し込み"},
			{"no":"1","name":"試弾申し込み"},
		];
    return {
      payment_status,
      status,

      displayMemoModal: false,
      memo: "",
      orders_id: null,

      orders: [],
			all_parPage: 5,
			all_currentPage: 1,

			searchForm: {
				buyer_name: "",
				seller_name: "",
				seller_mail: "",
				payment_status: "",
        status: "",
			},
    }
  },
	methods: {
    updateStatus: function(orders_id, status){
      if(confirm("ステータスを変更してもよろしいですか?")) {
        this.exec_update_status(orders_id, status);
      }
      return false;
    },
    async exec_update_status(orders_id, status) {
      let form = {};
      form['orders_id'] = orders_id;
      form['payment_status'] = status;
      form['admin'] = "1";
      this.$store.dispatch('order/put_order', {
        order: form,
      }).then(res => {
        console.log(res);
        alert('更新が完了しました。');
        for (let i = 0; i < this.orders.length; i++) {
          if ( String(this.orders[i]['orders_id']) == String(orders_id) ) {
            this.orders[i]['payment_status'] = status;
          }
        }
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
	  jumpMessageDetail: function(status, messages_id){
      window.open('/admin/message/0/'+String(status)+'/'+String(messages_id), '_blank')
      return false;
        // this.$router.push({path: '/admin/message/0/'+String(status)+'/'+String(messages_id)});
	  },
    jumpMemo(order) {
      this.orders_id = order['orders_id'];
      this.memo = order['memo'];
      this.displayMemoModal = true;
	  },
    async update_memo() {
      let form = {};
      form['orders_id'] = this.orders_id;
      form['memo'] = this.memo;
      form['admin'] = "1";
      this.$store.dispatch('order/put_order', {
        order: form,
      }).then(res => {
        console.log(res);
        alert('更新が完了しました。');
        this.displayMemoModal = false;
        for (let i = 0; i < this.orders.length; i++) {
          if ( String(this.orders[i]['orders_id']) == String(this.orders_id) ) {
            this.orders[i]['memo'] = this.memo;
          }
        }
        this.orders_id = null;
        this.memo = "";
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error.response.data);
        if ('error' in error.response.data) {
          alert(error.response.data['error']);
          window.scrollTo({
            top: 0,
          });
        }
      });
      return false;
    },
    jumpSeller: function (id) {
      window.open('/mypage?page=3&users_id='+id, '_blank')
      return false;
      // this.$router.push({path: '/mypage', query: {page: 3, users_id: id}});
      // return false;
    },
    jumpProductDetail: function (id) {
      window.open('/product/'+String(id), '_blank')
      return false;
      // this.$router.push({path: '/product/'+String(id)});
      // return false;
    },
	  async get_orders() {
		  this.$store.dispatch('order/search_order', {
        searchForm: this.searchForm,
      }).then(res => {
		    console.log(res);
		    let ret = res.data.orders;
        if ('orders' in ret) {
  		    this.orders = ret['orders'];
        } else {
  		    this.orders = [];
        }
		    console.log(this.orders);
        window.scrollTo({
          top: 0,
        });
		  }, error => {
		    console.log('error発生');
		    console.log(error);
		    this.$nextTick(() => {
          window.scrollTo({
            top: 0,
          });
		    });
  	  });
	  },
		allClickCallback: function (pageNum) {
      this.all_currentPage = Number(pageNum);
			this.$nextTick(() => {
				window.scrollTo({
					top: 0,
				});
			});
    },
  },
	created() {
		this.get_orders();
  },
	computed: {
		allGetOrders: function() {
			let current = this.all_currentPage * this.all_parPage;
			let start = current - this.all_parPage;
			return this.orders.slice(start, current);
		},
		allGetPageCount: function() {
			return Math.ceil(this.orders.length / this.all_parPage);
		},
	},
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/mypage/admin/application.vue